import { useCallback, useRef } from 'react';
import { LocationState } from 'shared/types';

import { getInitialPreviewRefMap } from '../helpers';
import { ListOffer } from '../types';
import { LocationListenerCallback, useLocationListener } from './useLocationListener';

export function useScrollToLastOpened(offers: ListOffer[]) {
    const previewRefMap = useRef(getInitialPreviewRefMap(offers));

    const scrollToPreviewListener = useCallback<LocationListenerCallback>((location) => {
        if (!location.state) {
            return;
        }

        const locationState = location.state as LocationState;
        const { lastOpenedOfferKey } = locationState;

        if (!lastOpenedOfferKey) {
            return;
        }

        window.history.replaceState({}, document.title);

        const node = previewRefMap.current[lastOpenedOfferKey];

        if (!node) {
            return;
        }

        node.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, []);

    useLocationListener(scrollToPreviewListener);

    return previewRefMap;
}
